import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  AfterViewInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Theme } from 'studio-components';
import { provideValueAccessor } from 'studio-components/shared/value-accessor.utils';

@Component({
  selector: 'studio-form-textarea',
  templateUrl: './form-textarea.component.html',
  styleUrls: ['./form-textarea.component.scss'],
  providers: [provideValueAccessor(() => FormTextareaComponent)],
})
export class FormTextareaComponent implements AfterViewInit {
  @ViewChild('textarea', { static: false }) textareaElement: ElementRef;
  @Input() public value: string;
  @Input() public uniqueId: string;
  @Input() public textareaAutosize = true;
  @Input() public minRows: number;
  @Input() public maxRows: number;
  @Input() public placeholder = '';
  @Input() public spellcheck = true;
  @Input() public initFocus = false;
  @Input() public theme: Theme;
  @Input() public disabled = false;
  @Output() valueSaved = new EventEmitter();

  ngAfterViewInit() {
    if (this.initFocus) {
      this.textareaElement.nativeElement.focus({ preventScroll: true });
    }
  }

  public save(value) {
    if (!this.disabled) {
      this.value = value;
      this.onChange(value);
      this.valueSaved.emit(value);
    }
  }

  /**
   * REACTIVE FORMS INTEGRATION
   */
  public onChange = (_: any) => {};
  public onTouched = (_: any) => {};

  // writes a new value to the textarea.
  public writeValue(value: any): void {
    this.value = value;
  }

  // function called when the control's value changes in the UI.
  public registerOnChange(fn): void {
    this.onChange = fn;
  }

  // function is called by forms API on initialization
  // to update the form model on blur/on touched.
  public registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  // set disabled state
  public setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
